import { GUEST_AVATAR_PATH } from '@/modules/misc/common/navbar/config.json';

import { updateProfilePicture } from './updateProfilePicture';

function getInitials(name) {
  const words = name
    .replace(/\(.*\)/, '')
    .replace(/[^\p{L} ]/gu, '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  if (words.length === 0) {
    return '';
  }

  const first = words[0].charAt(0);
  const last = words.length > 1 ? words[words.length - 1].charAt(0) : '';

  return (first + last).toUpperCase();
}

// Mirrors ManagerEntity::getInitials() when the first and last name come separately
function getInitialsFromNameParts(firstName, lastName) {
  const firstNameInitials = getInitials(firstName);
  const lastNameInitials = getInitials(lastName);

  if (lastNameInitials === '') {
    return firstNameInitials;
  }

  return firstNameInitials.charAt(0) + lastNameInitials.charAt(0);
}

export function updateUserName({ username, firstName = null, lastName = null }) {
  if (!username) {
    return;
  }
  const btnWrapper = document.querySelector('.ds-header__navbar__avatar__btn_img');
  const img = document.getElementById('profilePicture');

  const initials = firstName !== null && lastName !== null
    ? getInitialsFromNameParts(firstName, lastName)
    : getInitials(username);

  if (btnWrapper && (!img || img.src.includes(GUEST_AVATAR_PATH))) {
    btnWrapper.innerHTML = '';
    btnWrapper.textContent = initials;
  }

  if (btnWrapper) {
    btnWrapper.dataset.initials = initials;
  }
  // The VC navbar shows only the avatar, without the name
  const userNameElement = document.getElementById('userName');
  if (userNameElement) {
    userNameElement.innerText = username;
  }

  if (initials.length === 0) {
    updateProfilePicture(GUEST_AVATAR_PATH);
  }
}
